import { IncomingHttpHeaders } from 'http';
import { apiClient } from '@doda/api-client/util/apiClient';
import { VisaTypeResponse } from '@doda/api-client/aspida/@types';

/**
 * 在留資格(VISA)マスタを取得する
 * @param headers リクエストヘッダー
 * @returns 在留資格(VISA)マスタ（査証区分 > 在留資格区分の2階層）
 */
export const getVisaTypes = async (
  headers: IncomingHttpHeaders
): Promise<VisaTypeResponse[]> => {
  const response = await apiClient.api.v1.visaType.$get({
    config: { headers },
  });
  return response;
};
